<template>
<div>
    <div class="nooutline" :style="((height!=null)&&(!resizable))?{ 'height':height,'overflow-y':'auto',width:width }:false" tabindex="0" @keyup.down="selectNext" @keyup.up="selectPrev" @scroll="handleScroll"
         v-infinite-scroll="loadMoreItems" infinite-scroll-distance="10"
    >
    <wrapped-component :wrap="resizable"  v-if="!showEditor">
        <template #wrapper><vue-resizable :style="(height!=null)?('overflow-y:auto'):false" :active="(resizable)?['rb','r','b']:[]" :height="height" :width="width" ref="resizable" @mount="changeSize" @resize:move="changeSize"/></template>
        <table class="table table-bordered table-striped table-condensed2" :loading="loading" :key="pagecount" >
            <colgroup>
                <col v-if="check" style="width:1%">
                <col v-if="tree" style="width:1%">
                <col v-for="column in visiblecolumns" :key="column.field" :width="(column.width==null)?'*':column.width"/>
            </colgroup>
            <thead>
                <tr class="info" @contextmenu.prevent="openTitleContextMenu" v-if="hastitles">
                    <th v-if="check">
                      <input type="checkbox" v-model="CheckAll" @change="toggleAllCheck"/>
                    </th>
                    <th v-if="tree"></th>
                    <th v-for="column in visiblecolumns" :key='column.field' class="tablersticky">
                      <slot :name="'title.'+column.field" :column="column"><span v-html="column.title"></span></slot>
                        <span v-if="column.sortable" @click="setSortField(column)" class="pull-right"><span v-if="column!=sortfield" class="glyphicon glyphicon-sort tblsorticon"></span>
                            <span v-if="(column==sortfield)&&(sorttype==0)" class="glyphicon glyphicon-sort-by-attributes"></span>
                            <span v-if="(column==sortfield)&&(sorttype==1)" class="glyphicon glyphicon-sort-by-attributes-alt"></span>
                        </span>
                    </th>
                </tr>
                <tr v-if="hasfilters">
                    <td v-if="check"></td>
                    <td v-if="tree"></td>
                    <td v-for="column in visiblecolumns" :key='column.field' class="tablerstickyfilter">
                        <input v-if="column.filter=='input'" class="form-control input-sm" v-model="inputfilters[column.field]" :placeholder="$gettext('Поиск...')" @blur="applyFilters" @keydown.13="applyFilters"/>
                        <span v-if="column.filter=='date'" class='input-group datefilter'>
                            <input class="form-control input-sm" v-model="inputfilters[column.field].from" type="date" :placeholder="$gettext('От')"  @blur="applyFilters" @keydown.13="applyFilters"/>
                            <input class="form-control input-sm" v-model="inputfilters[column.field].to" type="date" :placeholder="$gettext('До')"  @blur="applyFilters" @keydown.13="applyFilters"/>
                        </span>
                        <select v-if="column.filter=='select'" class="form-control input-sm" v-model="inputfilters[column.field]"  @blur="applyFilters" @change="applyFilters" @keydown.13="applyFilters">
                            <option value=""></option>
                            <option value="#nodata" v-translate>-Пусто-</option>
                            <option v-for="v in allcolumnvalues(column.field)" :value="v" :key="v">{{ v }}</option>
                        </select>
                        <select v-if="(column.filter=='switch')&&column.cases" class="form-control input-sm" v-model="inputfilters[column.field]" @change="applyFilters" @blur="applyFilters" @keydown.13="applyFilters">
                          <option value=""></option>
                          <option v-for="(k,i) in column.cases" :key="i" :value="i">{{k}}</option>
                        </select>
                        <select v-if="column.filter=='yesno'" class="form-control input-sm" v-model="inputfilters[column.field]" @change="applyFilters" @blur="applyFilters" @keydown.13="applyFilters">
                          <option value=""></option>
                          <option value="false" v-translate>Нет</option>
                          <option value="true" v-translate>Да</option>
                        </select>
                        <select2 v-if="column.filter=='tagselect'" v-model="inputfilters[column.field]"  @change="applyFilters" @keydown.13="applyFilters" :settings="{ theme:'bootstrap',width:'100%',allowClear:'true',placeholder:'Фильтр' }"
                                 :options="allcolumntagvalues(column.field)">
                        </select2>
                    </td>
                </tr>
            </thead>
              <tbody :class="loading" :key="filterupdateindex">
              <template v-for="item in displayitems">
              <tr  :ref="'el_'+item.id" :key="item.__key" v-bind:selected="(itemSelected!==null)&&(itemSelected.id===item.id)"
                  @click="selectItem(item,$event)" @dblclick="$emit('dblclick',item)" v-bind:rowid="item.id"
                  v-bind:updated="item.__updated" :class="rowclass?rowclass(item):null" v-if="isRowFiltered(item)"
                  @contextmenu.prevent="(contextitems!==null)?openContextMenu(item,$event):null" v-tip="(tip!=null)?tip(item):null" v-tooltip.bottom="(tooltip!=null)?tooltip(item):null">
                <td v-if="check">
                  <input type="checkbox" v-model="item.__checked" @input="evToggleCheck(item,$event)"/>
                </td>
                <td v-if="tree">
                  <template v-if="(item.children!=null)&&(item.children.length>0)">
                      <span class="glyphicon treeicon"
                        :style="{ '--level':getTreeLevel(item) }"
                        :class="(item.__expanded)?'glyphicon-menu-down':'glyphicon-menu-right'"
                        @click="item.__expanded=(item.__expanded==null)?true:!item.__expanded;pagecount++"></span>
                      <input v-if="options.treecheck" type="checkbox" v-model="item.__checked" @change="toggleChildrenCheckbox(item)"/>
                  </template>
                  <template v-else>
                    <span v-if="!options.treecheck" class="glyphicon treeicon glyphicon-option-vertical"
                          :style="{ '--level':getTreeLevel(item) }"></span>
                    <span v-else class="treeicon" :style="{ '--level':getTreeLevel(item) }">
                      <input type="checkbox" v-model="item.__checked">
                    </span>
                  </template>
                </td>
                <slot name="templaterow" :item="item" :options="options">
                  <td v-for="column in visiblecolumns" :key='column.field' :class="column.class?column.class(item):null">
                    <wrapped-component :wrap="(draggable&&(column.draggable!==false)&&((typeof column.draggable!== 'function')||column.draggable(item)))">
                      <template #wrapper><drag :transfer-data="item" :class="draggable?draggable.class:''" @dragstart="dragStart(...arguments)" @dragend="dragEnd(...arguments)">
                        <span v-if="draggable&&draggable.image" slot="image"><slot name="drag.image" :item="item"></slot></span>
                      </drag></template>
                      <slot :name="column.field" :item="item">
                    <span v-if="column.type=='html'" v-html="item[column.field]"></span>
                        <span v-else-if="column.cases" v-html="column.cases[item[column.field]]"></span>
                    <span v-else-if="column.type=='yesno'" :class="(item[column.field]&&(item[column.field]!=='0'))?'text-success':'text-danger'">{{ (item[column.field]&&(item[column.field]!=='0'))?$gettext('Да'):$gettext('Нет') }}</span>
                      <span v-else-if="column.type=='tags'">
                        <template v-if="item[column.field]">
                          <span class="label label-info labeltag" v-for="(tag,tagid) in item[column.field]" v-html="tag" :key="tagid"></span>
                        </template>
                      </span>
                    <span v-else-if="column.dateformat">{{ item[column.field]|dateformat(column.dateformat) }}</span>
                    <template v-else>{{ item[column.field] }}</template></slot>
                    </wrapped-component>
                  </td>
                </slot>
              </tr>
                <slot name="afterrowtemplate" :item="item" :options="options"></slot>
              </template>
              </tbody>
        </table>
    </wrapped-component>
      <div v-if="showEditor">
        <div class="pull-left"><btn type="primary" @click="showEditor=false"><span class="glyphicon glyphicon-arrow-left"></span> Вернуться</btn></div>
        <div class="pull-right">
          <btn type="danger" @click="clearContextEditorCache" title="Сбросить сохранение и очистить кэш"><span class="glyphicon glyphicon-refresh"></span></btn>
          <btn type="success" @click="saveContextEditor"><span class="glyphicon glyphicon-ok"></span> Принять</btn>
        </div>
        <h2 class="centered">Редактор таблицы</h2>
        <alert type="danger" v-if="editorError" v-html="editorError"></alert>
        <div>
          <strong class="pull-left">Столбец</strong>
          <strong class="pull-right">Видимость</strong>
        </div><hr/>
        <draggable v-model="sortedcolumns">
          <div class="list-group-item"
               v-for="p in sortedcolumns"
               :key="p.column">
            <strong v-html="(p.title!=null)?p.title:p.column"></strong>
            <span class="pull-right"><toggle v-model="p.visible" :options="{ off:'Нет',offstyle:'danger',on:'Да',onstyle:'success',size:'small' }" title="Видимость"/></span>
          </div>
        </draggable>
      </div>
      <progresser class="tablerprogresser" :completed1="progress" :total1="100" :status="(progresstotal==null)?null:1"></progresser>
    </div>
    <div v-if="(allbuttons.length>0) || options.totalcount" class="tablerfooter" :style="footerStyle" :key="pagecount">
        <strong v-if="options.totalcount" class="totalcount">Всего: {{ items.length }}<span v-if="filteredcount && (filteredcount!=items.length)">, фильтр: {{ filteredcount }}</span>
            <template v-for="column in options.columns" >
                <span v-if="column.total" :key="column.field">, {{ column.title }}: {{ totalsum(column) }} <span v-if="filteredcount && (filteredcount!=items.length)">({{ filteredsum(column) }})</span></span>
            </template>
        </strong>

        <span class="tablerbuttons pull-right">
          <div class="btn-group">
            <button v-for="button in allbuttons" :key='button.action' class="btn btn-sm" :class="button.class" :disabled="(btnItemCheck(button))||(disabled)||(BtnsDisabled)" :title="button.hint" v-on:click="callfunc(button.action)" :ref="button.ref">
              <template v-if="!BtnsDisabled">
                <span v-if="button.glyph" class="glyphicon" :class="'glyphicon-'+button.glyph"></span>
                  <font-awesome-icon v-if="button.glyphfa" :icon="['fas',button.glyphfa ]"></font-awesome-icon>
              </template>
              <template v-else>
                <img src="/icons/loading.gif" height="15px" width="15px" title="Ожидайте..."/>
              </template>
              <span v-if="button.title"> {{ button.title }}</span>
            </button>
          </div>
        </span>
    </div>

        <context v-if="contextitems" ref="tablercontext">
            <li v-for="ci in contextitems" :key="ci.text"><a href="#" @click.prevent="callfunc(ci.action,contextSelected)">{{ ci.text }}</a></li>
        </context>
  <context ref="titlecontext" v-if="!nocolumneditor">
    <li><a href="#" @click.prevent="showContextEditor">Ред.таблицы</a></li>
  </context>
</div>

</template>

<script>
    import Vue from 'vue';
    import axios from 'axios';
    import moment from 'moment';
    import VueContext from 'vue-context'
    import VueResizable from 'vue-resizable'
    import WrappedComponent from 'vue-wrapped-component'
    import infiniteScroll from 'vue-infinite-scroll'
    import { VTooltip as VTip } from 'v-tooltip'
    import "../css/tooltip.css"
    import { Alert } from 'uiv'
    VTip.options={};
    VTip.options.defaultClass='tooltip-vue';
    VTip.options.defaultTemplate="<div class=\"tooltip-vue\" role=\"tooltip\"><div class=\"tooltip-arrow\"></div><div class=\"tooltip-inner\"></div></div>";

    export default {
        props: ['options','params','disabled','height','value','rowclass','resizable','width','scrollable','tooltip','nocolumneditor','tree','draggable',"buttons","displaylimit","unselect","check","checkchildren"],
        data:function(){
            return {
                items:[],
                filters:Object.assign({},this.filters,this.options.columns.reduce((a,d)=>{ if (d.filter!=null) a[d.field]=(d.filter=='date')?{ from:null,to:null }:""; return a;},{})),
                inputfilters:Object.assign({},this.filters,this.options.columns.reduce((a,d)=>{ if (d.filter!=null) a[d.field]=(d.filter=='date')?{ from:null,to:null }:""; return a;},{})),
                itemSelected:null,
                loading:false,
                pagecount:0,
                progresstotal:null,
                progress:0,
                filteredcount:0,
                contextSelected:null,
                resizewidth:null,
                sortfield:null,
                sorttype:null,
                altpressed:false,
                scrollops:{},
                showEditor:false,
                editorError:null,
                sortedcolumns:[],
                visiblecolumns:[],
                displaypos:0,
                fetchtime:null,
                BtnsDisabled:false,
                filtereditems:{},
                CheckAll:false,
                filterupdateindex:0
            }
        },
        computed:{
            hasfilters:function(){
                return this.options.columns.reduce( (hf,el)=> (hf||(el.filter!=null)),false);
            },
            hastitles:function(){
              return this.options.columns.reduce( (hf,el)=> (hf||(el.title!=null)),false);
            },
            contextitems:function(){
                if (this.options.context!=null) return this.options.context;
                if (this.allbuttons==null) return null;
                var c=this.allbuttons.map(b=>{  return { text:((b.title==null)?b.hint:b.title), action:b.action };});
                if (c.length==0) return null;
                return c;
            },
            footerStyle:function(){
                if (this.resizewidth!=null)
                    return "--width:"+this.resizewidth+"px";
                else
                    return "";
            },
            displayitems(){
              if (this.displaylimit==null) return this.sorteditems;
              return this.sorteditems.filter(a=>this.isRowFiltered(a)).slice(0,this.displaypos+parseInt(this.displaylimit));
            },
            sorteditems(){
                if (this.items==null) return [];
//                let it=(this.hasfilters)?this.items.filter(this.isRowFiltered):this.items;
//                console.log(it);
                this.pagecount;
                if ((this.tree)&&(this.sortfield==null)) return this.treeItems(this.items);
                if (this.sortfield==null) return this.items;
                var res=[...this.items];
                res.sort(this.sortCompare);
                if (this.tree) return this.treeItems(res);
                return res;
            },
            allbuttons(){
              let r1=(this.options.buttons!=null)?this.options.buttons:[];
              let r2=(this.buttons!=null)?this.buttons:[];
              return [...r1,...r2];
            }
        },
        methods:{
            selectItem:function(item,event=null){
                if ((this.check)&&(event!=null)&&(event.ctrlKey)){
                  if (item.__checked==null) Vue.set(item,"__checked",true);
                  else
                    Vue.set(item,"__checked",!item.__checked);
                }
                if ((this.options!=null)&&(this.options.notSelectable)) { return this.$emit("select",item); }
                if ((this.unselect)&&(this.itemSelected==item)) {
                  this.itemSelected=null;
                  this.$emit("select",null);
                  this.$emit("input",null);
                  this.$emit("unselect",item);
                  return;
                }
                this.itemSelected=item; 
                this.$emit("select",item); 
                this.$emit("input",item);
                if (this.tree&&!this.isRowVisible(item))
                {
                  this.expandParent(item);
                }
            },
            fetchData:async function(){
                if (this.options.query==null)
                {
                    this.items=((this.params==null)||(!Array.isArray(this.params)))?[]:this.params;
                    this.filtereditems={};
                    this.loading=false;
                    this.$emit('load');
                    return;
                }
                this.$emit('before-load');
                var vars=new FormData();
                vars.set('actiondata',this.options.query);
                for(var prop in this.params)
                {
                    vars.set(prop,this.params[prop]);
                    if ((this.options.nullparam!=1)&&(this.params[prop]==null))
                    {
                        this.items=[];
                        return;
                    }
                }
                if (!this.options.stream)
                {
                    await axios.post("headless.php?actiondata="+this.options.query,vars).then((jd)=>{
                        var selExists=false;
                        this.fetchtime=jd.headers['x-servertime'];
                        jd.data.map((d)=>{ 
                            d.__key=d.id;
                            d.__updateCount=0;
                            if ((this.itemSelected!=null)&&(d.id==this.itemSelected.id))
                            {
                                selExists=true;
                                this.$emit("input",d);
                            }
                            return d; 
                        });
                        if (!selExists){ 
                            this.itemSelected=null;
                            this.$emit("input",null);
                        }
                        this.items=jd.data;
                        this.filtereditems={};
                        this.loading=false;
//                        for(var i in this.filters){ this.filters[i]="";};
                        this.$emit('load');
                    });
                }
                else
                {
                    await axios.post("headless.php?action=registerQuery&query="+this.options.query,this.params).then((code)=>{
                        var es=new EventSource("headless.php?action=fetchQuery&id="+code.data);
                        es.tabler=this;
                        this.code=code.data;
                        this.pagecount=false;
                        this.progress=0;
                        this.fetchtime=code.headers['x-servertime'];
                        this.$emit("onprogress",0);
                        es.onmessage=function(event)
                        {
                            if ((event.lastEventId==="0")||(this.tabler.loading))
                            {
                                this.tabler.items=[];
//                                this.tabler.filters={};
                                this.tabler.loading=false;
                            }
                            var data=JSON.parse(event.data);
                            this.tabler.progress=data.progress;
                            if (data.total!=null) this.tabler.progresstotal=data.total;
                            console.log("this code:"+this.tabler.code+",Tabler code:"+data.code);
                            if ((data.code!=null)&&(data.code!=this.tabler.code)) {
                              this.close();
                              return;
                            }
                            if (data.data!=null)
                            {
                                var data1=data.data.map((d)=>{ 
                                    d.__key=d.id;
                                    d.__updateCount=0;
                                    if ((this.tabler.itemSelected!=null)&&(d.id==this.tabler.itemSelected.id))
                                    {
                                        this.tabler.$emit("input",d);
                                    }
                                    return d; 
                                });
                            }
                            else    
                                var data1=[];
                            Array.prototype.push.apply(this.tabler.items, data1);
                            if (event.lastEventId==="-1")
                            {
                                this.close();
                                this.tabler.progresstotal=null;
                                this.tabler.$emit('load',this.tabler.items);
                                this.tabler.$emit("onprogress",null);
                            }
                            if (!this.tabler.displaylimit||(event.lastEventId==-1)||((this.tabler.pagecount==0)&&(this.tabler.items.length>this.tabler.displaylimit)))
                              this.tabler.pagecount=event.lastEventId;
                            this.tabler.$emit("onprogress",this.tabler.progress);
                        };
                    });
                }
            },
            isRowVisible(item){
              if ((!this.tree)||(!item.__parent)) return true;
              if ((!item.__parentrow)||(item.__parentrow[0]==null)||(typeof item.__parentrow[0]=="string"))
                item.__parentrow=this.sorteditems.filter(a=>(a.id==item.__parent));
              let prow=item.__parentrow;
              if (prow.length!=0) {
                if (!this.isRowVisible(prow[0]) || !prow[0].__expanded)
                  return false;
              }
              return true;
            },
            isRowFiltered:function(item,extraFilters){
                let toshow=true;
                if (this.hasfilters==false) return this.isRowVisible(item);
                let isfiltering=false;
                this.options.columns.map((c)=>{
                    let f=this.filters[c.field];
                    if ((extraFilters!=null)&&(extraFilters[c.field]!=null))
                      f=extraFilters[c.field];
                    if ((f!=null)&&(f!==""))
                      isfiltering=true;
                    if ((c.filter)&&(f=="#nodata"))
                    {
                        if ((item[c.field]!=null)&&(item[c.field].trim()!="")) toshow=false;
                    }
                    else
                    {
                        if ((c.filter=="input")&&(f!=null)
                            &&(f.trim()!="")
                            &&((item[c.field]==null)||((item[c.field]!=null)
                                &&((typeof(item[c.field])=="string")||(typeof(item[c.field])=="number"))
                                &&((item[c.field].toString().trim()=="")||(item[c.field].toString().toLowerCase().search(f.trim().toLowerCase())==-1))))) toshow=false;
                        if ((c.filter=="select")&&(f!=null)&&(f!="")&&(item[c.field]!=f)) toshow=false;
                        if ((c.filter=="switch")&&(f!=null)&&(f!="")&&(item[c.field]!=f)) toshow=false;
                        if ((c.filter=="date")&&(f!=null)&&((f.from!=null)&&(f.from!="")&&((item[c.field]===null)||(moment(String(item[c.field])).format("YYYY-MM-DD")<f.from)))) toshow=false;
                        if ((c.filter=="date")&&(f!=null)&&((f.to!=null)&&(f.to!="")&&((item[c.field]===null)||(moment(String(item[c.field])).format("YYYY-MM-DD")>f.to)))) toshow=false;
                        if ((c.filter=="yesno")&&(f!=null)&&(f=="true")&&(item[c.field]!==true)&&(item[c.field]!==1)) toshow=false;
                        if ((c.filter=="yesno")&&(f!=null)&&(f=="false")&&((item[c.field]===true)||(item[c.field]===1))) toshow=false;
                        if ((c.filter=="tagselect")&&(f!==null)&&(f!="")&&(!((new Set(item[c.field])).has(f)))) toshow=false;
                    }
                });
                this.filtereditems[item[this.options.key]]=toshow;
//                item.__filtered=toshow;
                if (isfiltering&&toshow) return true;
                return toshow&&this.isRowVisible(item);
            },
            allcolumnvalues:function(field)
            {
                var allitems=Array.from(new Set(this.items.map(v=>v[field])));
                return allitems.sort();
            },
            allcolumntagvalues:function(field)
            {
              let alltags=this.items.reduce((a,b)=>{
                if (b[field]!=null) b[field].forEach(i=>{
                  a.add(i);
                });
                return a;
              },new Set());
              let tags=Array.from(alltags).map(v=>{ return {id:v, text:v}; });
              return tags.sort();
            },
            callfunc:function(method,subject=null){
                if (typeof(method)=="function")
                    method((subject==null)?this.itemSelected:subject);
                if (typeof(method)=="string")
                    this.$root[method]((subject==null)?this.itemSelected:subject);
            },
            countfiltered:function(){
                var c=this.items.filter(d=> this.filtereditems[d[this.options.key]]).length;
                if ((c==this.items.length)&&(this.filteredcount!=null)) this.filteredcount=null;
                if (this.filteredcount!=c) this.filteredcount=c;
            },
            openContextMenu:function(row,event){
                this.contextSelected=row;
                this.$refs.tablercontext.open(event);
            },
            openTitleContextMenu:function(event){
              if (!this.nocolumneditor)
                this.$refs.titlecontext.open(event);
            },
            refresh:function(force=null){
              if ((this.options.updatequery==null)||(force===true))
                this.fetchData();
              else
                this.fetchUpdates();
            },
            startloading(){
                this.loading="loading";
            },
            changeSize:function(arr){
                this.resizewidth=arr.width;
                this.$emit("resize",arr);
            },
            setSortField(column){
                if (this.sortfield==column)
                    this.sorttype=(this.sorttype==1)?0:1;
                else{
                    this.sortfield=column;
                    this.sorttype=0;
                }   
            },
            sortCompare:function(a,b){
                var field=(this.sortfield==null)?"id":this.sortfield.field;
                let a1=a[field];
                let b1=b[field];
                if (this.sortfield.sortable=="int")
                {
                    a1=parseInt(a1??0);
                    b1=parseInt(b1??0);
                }
                if (this.sortfield.sortable=="float")
                {
                  a1=parseFloat(a1??0);
                  b1=parseFloat(b1??0);
                }
                if ((a1===null)||(a1<b1)) return (this.sorttype!=1)?-1:1;
                if ((b1===null)||(a1>b1)) return (this.sorttype!=1)?1:-1;
                return 0;
            },
            totalsum(column){
                return this.items.reduce((a,b)=>(a + ((isNaN(parseInt(b[column.field])))?0:parseInt(b[column.field]))),0);
            },
            filteredsum(column){
                var c=this.items.filter(d=> this.filtereditems[d[this.options.key]]);
                return c.reduce((a,b)=>a+parseInt(b[column.field]),0);
            },
            selectNext(e){
              let key=this.options.key;
              let i=this.sorteditems.findIndex(i=>((this.itemSelected!=null)&&(i[key]==this.itemSelected[key])));
              if (i==null) return;
              i++;
              let item=this.sorteditems[i];
              while ((item)&&(!this.isRowFiltered(item))) {
                  i++;
                  item=this.sorteditems[i];
              }
              if (item) this.selectItem(item);
            },
            selectPrev(e){
              let key=this.options.key;
              let i=this.sorteditems.findIndex(i=>((this.itemSelected!=null)&&(i[key]==this.itemSelected[key])));
              if (i==null) return;
              i--;
              let item=this.sorteditems[i];
              while ((item)&&(!this.isRowFiltered(item))) {
                i--;
                item=this.sorteditems[i];
              }
              if (item) this.selectItem(item);
            },
            handleScroll(e){
//              console.log(e);
            },
            showContextEditor(){
              this.editorError=null;
              this.showEditor=true;
            },
            saveContextEditor(){
              if (this.sortedcolumns.filter(a=>a.visible).length==0){
                this.editorError="Покажите хотя бы один столбец.";
                return;
              }
              this.visiblecolumns=this.sortedcolumns.filter(a=>a.visible);
              localStorage.setItem("tablercolumns_"+this.options.query,JSON.stringify(this.sortedcolumns));
              this.showEditor=false;
            },
            clearContextEditorCache(){
              localStorage.removeItem("tablercolumns_"+this.options.query);
              this.sortedcolumns=this.options.columns.map(a=>{
                a.visible=true;
                return a;
              });
              this.visiblecolumns=this.sortedcolumns.filter(a=>a.visible);
              this.showEditor=false;
            },
            treeItems(el){
              if (el==null) return [];
              let res=[];
              el.map(a=> {
                res.push(a);
                if (a.children != null) {
                  a.children.map(b => {
                    b.__parent = a.id;
                  });
                  a.__expanded=(a.__expanded==null)?(a.isDefaultExpanded===true):a.__expanded;
                }
                this.treeItems(a.children).map(b=>{
                  res.push(b);
                });
              });
              return res;
            },
            expandParent(item){
              if (item.__parent==null) return;
              let prow=this.sorteditems.filter(a=>(a.id==item.__parent));
              if (prow.length!=0){
                 prow[0].__expanded=true;
                 this.expandParent(prow[0]);
              }
            },
            dragClone(original){
              if (this.dragclone===null) return original;
              return this.dragclone(original);
            },
            dragStart(a,b){
               this.$emit("dragstart",{ data:a,event:b });
            },
            dragEnd(a,b){
              this.$emit("dragend",{ data:a,event:b });
            },
            applyFilters(){
              let filters={ ...this.inputfilters };
              this.sortedcolumns.forEach(a=>{
                if (typeof a.normalize=="function")
                {
                  filters[a.field]=a.normalize(filters[a.field]);
                }
              });
              this.filters=filters;
            },
            loadMoreItems(){
              if (!this.displaylimit) return;
              if (this.displaypos>=this.items.length) return;
              this.displaypos+=5;
              this.pagecount++;
            },
          fetchUpdates:async function(){
              if ((this.options.updatequery==null)||(this.fetchtime ==null)) return;
              this.$emit('before-load');
              var vars=new FormData();
              vars.set('actiondata',this.options.updatequery);
              vars.set('fetchtime',this.fetchtime);
              for(var prop in this.params)
              {
                vars.set(prop,this.params[prop]);
              }
                await axios.post("headless.php?actiondata="+this.options.updatequery,vars).then((jd)=>{
                  var selExists=false;
                  this.fetchtime=jd.headers['x-servertime'];
                  jd.data.map((d)=>{
                    d.__key=d.id;
                    d.__updateCount=0;
                    if ((this.itemSelected!=null)&&(d.id==this.itemSelected.id))
                    {
                      selExists=true;
                      this.$emit("input",d);
                    }
                    return d;
                  });
                  if (!selExists){
                    this.itemSelected=null;
                    this.$emit("input",null);
                  }
                  if ((jd.data!=null)&&(jd.data!=""))
                  {
                    jd.data.map(a=>{
                      let k=this.items.findIndex(b=>(b.__key==a.__key));
                      if ((k==-1)&&(a._deleted!=1))
                        this.items.push(a);
                      else
                        if (a._deleted==1)
                          this.items.splice(k,1);
                        else
                          this.items[k]=a;
                    });
                  }
                  this.pagecount++;
                  this.$emit('load');
                });
          },
          getTreeLevel(item){
              return (item.__parentrow==null)?0:(this.getTreeLevel(item.__parentrow[0])+1);
          },
          disableButtons(){
            this.BtnsDisabled=true;
          },
          enableButtons(){
            this.BtnsDisabled=false;
          },
          btnItemCheck(button){
              let res=true;
              if (button.condition!=null){
                if (!button.condition(this.itemSelected)) { res=false; }
              }
              else
              {
                if (button.onitem&&(this.itemSelected==null)) res=false;
              }
              return !res;
          },
          toggleChildrenCheckbox(item){
            let v=item.__checked;
            item.children?.forEach(a=>{
              Vue.set(a,"__checked",v);
            })
          },
          toggleAllCheck(){
            this.items.forEach(a=>{
              if (this.isRowFiltered(a))
                Vue.set(a,"__checked",this.CheckAll);
              if (this.tree)
                this.toggleTreeCheck(a.children??[]);
            });
          },
          toggleTreeCheck(arr)
          {
            arr.forEach(a=>{
              if (this.isRowFiltered(a))
                a.__checked=this.CheckAll;
              if (this.tree)
                this.toggleTreeCheck(a.children??[]);
            });
          },
          evToggleCheck(item,e)
          {
            if (this.checkchildren)
            {
              this.toggleChildren(item,!item.__checked);
            }
          },
          toggleChildren(item,v)
          {
            item.children?.forEach(a=>{
              Vue.set(a,"__checked",v);
              this.toggleChildren(a,v)
            });
          },
          allTreeItems(items)
          {
            if (items==null)
            {
              return this.allTreeItems(this.items);
            }
            let arr=[];
            items.forEach(i=>{
              const { children,...j}=i;
              arr.push(j);
              if (i.children!=null)
                arr=arr.concat(this.allTreeItems(i.children));
            });
            return arr;
          }
        },
        created:function(){
            this.loading='loading';
//            this.filters=this.options.columns.reduce((a,d)=>{ if (d.filter!=null) a[d.field]=(d.filter=='date')?{ from:null,to:null }:""; return a;},{});
        },
        mounted:function(){
            let vc=localStorage.getItem("tablercolumns_"+this.options.query);
            if (this.nocolumneditor) vc=null;
            if (vc==null){
              this.sortedcolumns=this.options.columns.map(a=>{
                a.visible=true;
                return a;
              });
            }
            else{
              this.sortedcolumns=JSON.parse(vc);
            }
            this.visiblecolumns=this.sortedcolumns.filter(a=>a.visible);
            this.fetchData();
            if (this.tree&&(this.value!=null))
              this.$nextTick(()=>{
                this.expandParent(this.value);
              });
        },
        watch:{
            params: {
                deep:true,
                handler:function(v1,v2){ 
                    if (JSON.stringify(v1)!=JSON.stringify(v2))
                    {
                        this.loading='loading';
                        this.fetchData(); 
                    }
                }
            },
            value: function(value){ 
                this.itemSelected=value;
                if (value!=null)
                {
                  let k='el_'+value.id;
                  if ((this.$refs[k]!=null)&&(this.$refs[k][0]!=null))
                    this.$refs[k][0].scrollIntoViewIfNeeded(true);
                  if (this.tree){
                    this.expandParent(value);
                  }
                }

            },
            filters:{
                deep:true,
                handler:function(v){
                    this.filterupdateindex++;
                    this.$nextTick(this.countfiltered);
                    this.$nextTick(()=>this.$emit("refilter"));
                }
            }
        },
        components:{
            "context":VueContext,
            "wrapped-component":WrappedComponent,
        },
        directives:{
            "tip":VTip,
            infiniteScroll,
        },
    }



</script>

<style>
    @import '~vue-context/dist/css/vue-context.css';
</style>

<style scoped>
    tr[selected] td { background-color: #66CCFF !important }

    table[loading]
    {
        background-color:"gray";
        opacity:".8";
        filter:blur(2px);
    }

    div.tablerbuttons {
        right: 20px;
        position: absolute;
    }

    .tablerfooter {
        background-color:#dff0d8;
        width:var(--width);
        height:30px;
    }

    .tablersticky {
        position: sticky;
        top: 0;
        z-index:10;
        vertical-align: top;
    }

    .tablerstickyfilter {
        position: sticky;
        top: 28px;
        z-index:10;
    }

    span.tblsorticon:not(:hover){
        opacity: 0.33;
    }

    .datefilter input {
        width:49%;
    }

    .nooutline {
        outline: none;
    }

    .scroller {
      height: 100%;
    }

    div[draggable='true']
    {
      width:100%;
      height:100%;
    }

    tbody tr td {
      height:1px;
      width:1px;
    }

    .tablerprogresser
    {
      position: absolute;
      top:50%;
      left:50%;
      z-index:100001;
    }

    span.treeicon{
      padding-left:calc(var(--level) * 20px);
    }

    span.labeltag{
      margin-right: 2px;
    }

</style>
